module.exports = __webpack_public_path__ + "img/engineering__fence--left.61a397c5.svg";